import { generateStoreNameWithType } from "@cinch-nx/landing-ui-shared";
export function storeStaticPaths({ links  }) {
    const paths = [];
    for (const linkKey of Object.keys(links)){
        if (links[linkKey].is_folder) {
            continue;
        }
        const slug = links[linkKey].slug.split("/")[1];
        paths.push({
            params: {
                slug
            }
        });
    }
    return paths;
}
export const generateFallbackTitle = (storeName)=>{
    const cinchStoreText = generateStoreNameWithType(storeName);
    return `${cinchStoreText} | Buy used cars in ${storeName}`;
};
export const generateFallbackDescription = (storeName)=>{
    const storeType = storeName === "Corby" ? "warehouse" : "store";
    return `Welcome to the cinch ${storeType} in ${storeName}, offering used cars, part exchange & car viewing. Visit the cinch ${storeType} ${storeName} for faff-free car buying.`;
};
